import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const BahamasFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14310'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14310)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#22B7D5'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#22B7D5'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 9.33329H20V4.66663H0V9.33329Z'
					fill='url(#paint0_linear_2332_14310)'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 0L9.52381 7L0 14V0Z'
					fill='#262626'
				/>
			</g>
			<defs>
				<linearGradient
					id='paint0_linear_2332_14310'
					x1='0'
					y1='4.66663'
					x2='0'
					y2='9.33329'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='#FCE569' />
					<stop
						offset='1'
						stopColor='#FADF52'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default BahamasFlagIcon;
